const PAGE_SIZE = 5

export default {
  PAGE_SIZE,
}
